import React from 'react';
import { FiltersSkinType } from 'src/domains/layouts/webview/components/filters/FiltersSkin';

export interface TabItemType {
    key: string | number;
    label: React.ReactNode;
    labelDisabled: boolean;
    content: React.ReactElement;
    isActive: () => boolean;
    setActive: () => void;
    isFinished: boolean;
}

interface TabsPropsType {
    className?: string;
    items: Array<TabItemType>;
    setRefMenu?: (item: HTMLElement | null) => void;
    skin?: FiltersSkinType;
}

export class TabsState {
    public constructor(private readonly props: TabsPropsType) {}

    public setRefMenu = (item: HTMLElement | null): void => {
        const { setRefMenu } = this.props;
        if (setRefMenu !== undefined) {
            setRefMenu(item);
        }
    };
}
